import React, { memo, useMemo } from "react";
import { useMastersContext } from "../../../../contexts/masters.context";

function ColorPricingCategorySelectFilter({ column }) {
  const { filterValue, setFilter, optionLabelField, optionValueField } = column;

  const { colorPricingCategoryState } = useMastersContext();

  const defaulValueField = "pricingType";
  const defaultLabelField = "cpC_ID";

  const options = useMemo(
    () =>
      colorPricingCategoryState.data.map((cpc) => {
        return {
          value: cpc[optionValueField || defaulValueField],
          label: cpc[optionLabelField || defaultLabelField],
        };
      }),
    [colorPricingCategoryState.data]
  );

  return (
    <>
      <select
        className="custom-select custom-select-sm"
        onChange={(e) => setFilter(e.currentTarget.value)}
        defaultValue={filterValue || ""}
      >
        <option value="">All</option>
        {options.map((option, i) => (
          <option value={option.value} key={i}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
}

export default memo(ColorPricingCategorySelectFilter);
